import { useEffect } from "react";
import { Link } from "react-router-dom";

const editorial = [
  { img: "https://images.unsplash.com/photo-1701365676249-9d7ab5022dec?crop=entropy&cs=srgb&fm=jpg&q=85", tag: "The Everyday Edit", title: "Ease in Ivory", span: "lg:col-span-2 lg:row-span-2" },
  { img: "https://images.unsplash.com/photo-1631041047692-884b00d328d5?crop=entropy&cs=srgb&fm=jpg&q=85", tag: "For The Little Ones", title: "Young Royalty", span: "" },
  { img: "https://images.unsplash.com/photo-1744551358303-46edae8b374b?crop=entropy&cs=srgb&fm=jpg&q=85", tag: "After Dark", title: "Onyx Evenings", span: "" },
  { img: "https://images.unsplash.com/photo-1710242350089-65eef7e49364?crop=entropy&cs=srgb&fm=jpg&q=85", tag: "The Festive Edit", title: "Indigo Celebrations", span: "lg:col-span-2" },
  { img: "https://images.unsplash.com/photo-1628250521470-28c1fc54616c?crop=entropy&cs=srgb&fm=jpg&q=85", tag: "Wedding Season", title: "Merlot & Gold", span: "" },
];

export default function Lookbook() {
  useEffect(() => { document.title = "Lookbook — KKashigari India"; window.scrollTo(0, 0); }, []);
  return (
    <div data-testid="lookbook-page" className="max-w-[1400px] mx-auto px-5 lg:px-10 py-12 lg:py-16">
      <div className="text-center mb-14">
        <div className="uplabel mb-3">The KKashigari Lookbook</div>
        <h1 className="font-serif text-5xl sm:text-6xl text-[var(--bronze)]">Worn With Intention</h1>
        <p className="text-[var(--olive)] mt-4 max-w-xl mx-auto">An editorial exploration of our seasons — silhouettes photographed in warm, natural light.</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-4 auto-rows-[280px] lg:auto-rows-[320px] gap-4 lg:gap-6">
        {editorial.map((e, i) => (
          <Link to="/shop" key={i} className={`group relative overflow-hidden ${e.span} fade-up`} style={{ animationDelay: `${i * 80}ms` }}>
            <img src={e.img} alt={e.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2b2415]/70 to-transparent" />
            <div className="absolute bottom-6 left-6">
              <div className="uplabel text-[#FBF7DE]/80">{e.tag}</div>
              <div className="font-serif text-3xl text-[#FBF7DE] mt-1">{e.title}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
